import api from '@api/endpoints';
import { setAlert } from '@store/actions/alertActions';
import { RDA_DASHBOARD_CONSTANTS as actionTypes } from '@store/constants';
import { ALERT_STATUS_TYPE } from '@constants';


export const getTrueLayerBalance =
  ({ onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.rdaDashboard.getTrueLayerBalance();
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
export const saveHoliday =
  ({ reqBody, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      await api.rdaDashboard.saveHoliday({ reqBody });
      onSuccess && onSuccess();
    } catch (error) {
      console.error(error?.message);
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

/**
 * @Depricated method
 * @param onSuccess
 * @param onComplete
 * @returns {(function(*): Promise<void>)|*}
 */
 export const getYblBalance =
  ({ onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.rdaDashboard.getYblBalance();
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const getYblLiveBalance = ({
  onSuccess,
  onComplete
}) => async (dispatch) => {
  try {
    const { data } = await api.rdaDashboard.getYblLiveBalance();
    onSuccess && onSuccess(data);
  } catch (error) {
    dispatch(
      setAlert({
        title: error?.message,
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
  } finally {
    onComplete && onComplete();
  }
};


export const getYblPotBalance =
  ({ onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.rdaDashboard.getYblPotBalance();
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const reInitializeStuckFulfillmentTransfers = ({
  onSuccess,
  onComplete
}) => async (dispatch) => {
  try {
    await api.rdaDashboard.reInitializeStuckFulfillmentTransfers();

    onSuccess && onSuccess();

    dispatch(
      setAlert({
        title: 'Stuck Fulfillment Transfers Re-initialized Successfully',
        status: ALERT_STATUS_TYPE.SUCCESS
      })
    );
  } catch (error) {
    console.error(error?.message);
    dispatch(
      setAlert({
        title: error?.message,
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
  } finally {
    onComplete && onComplete();
  }
}

export const getRdaGbpBalance =
  ({ onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.rdaDashboard.getRdaGbpBalance();
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
export const getRdaInrBalance =
  ({ onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.rdaDashboard.getRdaGbpBalance();
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
export const getOverallTxns =
  ({ status, fromDate, pageNumber, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.GETTING_OVERALL_TXNS
      });

      const { data } = await api.rdaDashboard.getOverallTxns({
        status,
        fromDate,
        pageNumber,
        pageSize
      });

      dispatch({
        type: actionTypes.GET_OVERALL_TXNS_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );

      dispatch({
        type: actionTypes.GET_OVERALL_TXNS_FAIL,
        payload: {
          message: error?.message
        }
      });
    }
  };

export const getTrueLayerPartnerTxns =
  ({ fromDate, pageNumber, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.GETTING_TL_TXNS
      });

      const { data } = await api.rdaDashboard.getTrueLayerPartnerTxns({
        fromDate,
        pageNumber,
        pageSize
      });

      dispatch({
        type: actionTypes.GET_TL_TXNS_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );

      dispatch({
        type: actionTypes.GET_TL_TXNS_FAIL,
        payload: {
          message: error?.message
        }
      });
    }
  };

export const getClearBankPartnerTxns =
  ({ transactionType, fromDate, pageNumber, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.GETTING_CB_TXNS
      });

      const { data } = await api.rdaDashboard.getClearBankPartnerTxns({
        fromDate,
        pageNumber,
        pageSize,
        transactionType
      });

      dispatch({
        type: actionTypes.GET_CB_TXNS_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );

      dispatch({
        type: actionTypes.GET_CB_TXNS_FAIL,
        payload: {
          message: error?.message
        }
      });
    }
  };

export const getYblPartnerTxns =
  ({ fromDate, pageNumber, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.GETTING_YBL_PARTNER_TXNS
      });

      const { data } = await api.rdaDashboard.getYblPartnerTxns({
        fromDate,
        pageNumber,
        pageSize
      });

      dispatch({
        type: actionTypes.GET_YBL_PARTNER_TXNS_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch(
        setAlert({
          title: error?.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );

      dispatch({
        type: actionTypes.GET_YBL_PARTNER_TXNS_FAIL,
        payload: {
          message: error?.message
        }
      });
    }
  };
export const getAllHolidays = () => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.GETTING_HOLIDAY_DATA
    });

    const { data } = await api.rdaDashboard.getHolidays();

    dispatch({
      type: actionTypes.GETTING_HOLIDAY_DATA_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch({ type: actionTypes.GETTING_HOLIDAY_DATA_FAILURE });
  }
};

export const softDeleteHoliday =
  ({ id, onSuccess }) =>
  async (dispatch) => {
    try {
      await api.rdaDashboard.softDeleteHoliday(id);
    } catch (error) {
      dispatch(setAlert({ title: 'Error Deleting Holiday', status: ALERT_STATUS_TYPE.ERROR }));
    } finally {
      onSuccess && onSuccess();
    }
  };
export const getClearBankAccountDetails =
  ({ account_type, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      dispatch({ type: actionTypes.GETTING_CLEAR_BANK_ACCOUNT_DETAILS });
      const { data } = await api.rdaDashboard.getClearBankAccountDetails();
      onSuccess && onSuccess(data);
    } catch (error) {
      console.error(error?.message);
      dispatch(setAlert({ title: error?.message, status: ALERT_STATUS_TYPE.ERROR }));
    } finally {
      onComplete && onComplete();
    }
  };
export const getSafeGaurdingBalance =
  ({ onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.rdaDashboard.getSafeGuardingBalance();
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(setAlert({ title: error?.message, status: ALERT_STATUS_TYPE.ERROR }));
    } finally {
      onComplete && onComplete();
    }
  };
export const getOperatingAccountBalance =
  ({ onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.rdaDashboard.getOperatingAccountBalance();
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(setAlert({ title: error?.message, status: ALERT_STATUS_TYPE.ERROR }));
    } finally {
      onComplete && onComplete();
    }
  };

export const sweepOutBalanceSafeGuarding =
  ({ onComplete }) =>
  async (dispatch) => {
    try {
      await api.rdaDashboard.sweepOutBalanceSafeGuarding();
      dispatch(
        setAlert({
          title: 'Successfully sweeped out safegaurding balance',
          status: 'success'
        })
      );
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
export const withdrawFundsFromSafeguardingAccount =
  ({ onComplete }) =>
  async (dispatch) => {
    try {
      await api.rdaDashboard.withdrawFundsFromSafeguardingAccount();
      dispatch(
        setAlert({
          title: 'Successfully withdrew funds from safeguarding account',
          status: 'success'
        })
      );
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const withdrawFundsFromOperatingAccountRDA =
  ({ onComplete }) =>
  async (dispatch) => {
    try {
      await api.rdaDashboard.withdrawFundsFromOperatingAccountRDA();
      dispatch(
        setAlert({
          title: 'Successfully withdrew funds from operating account (RDA)',
          status: 'success'
        })
      );
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const withdrawFundsFromOperatingAccountVDA =
  ({ onComplete }) =>
  async (dispatch) => {
    try {
      await api.rdaDashboard.withdrawFundsFromOperatingAccountVDA();
      dispatch(
        setAlert({
          title: 'Successfully withdrew funds from operating account (VDA)',
          status: 'success'
        })
      );
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const withdrawRefundedFundsFromOperating =
  ({ onComplete }) =>
  async (dispatch) => {
    try {
      await api.rdaDashboard.withdrawRefundedFundsFromOperating();
      dispatch(
        setAlert({
          title: 'Successfully withdrew refunded funds from operating account',
          status: 'success'
        })
      );
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const getYblDowntimeList = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.GETTING_YBL_DOWNTIME_LIST });
    const { data } = await api.rdaDashboard.getYblDowntimeList();
    dispatch({ type: actionTypes.GET_YBL_DOWNTIME_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch(
      setAlert({
        title: error?.message,
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
    dispatch({
      type: actionTypes.GET_YBL_DOWNTIME_LIST_FAIL,
      payload: { message: error?.message }
    });
  }
};

export const createYblDowntime = ({ payload, onSuccess, onComplete }) => async (dispatch) => {
  try {
    await api.rdaDashboard.createDowntime(payload);
    dispatch(setAlert({ title: 'Downtime created successfully', status: ALERT_STATUS_TYPE.SUCCESS }));
    onSuccess && onSuccess();
  } catch (error) {
    dispatch(setAlert({ title: error?.message || 'Failed to create downtime', status: ALERT_STATUS_TYPE.ERROR }));
  } finally {
    onComplete && onComplete();
  }
};
export const getFulfillmentBalances = () => async (dispatch) => {
  dispatch({ type: actionTypes.GETTING_FULFILLMENT_BALANCES });
  try {
    const { data } = await api.rdaDashboard.getFulfillmentBalances();
    dispatch({ type: actionTypes.GET_FULFILLMENT_BALANCES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: actionTypes.GET_FULFILLMENT_BALANCES_FAIL, payload: { message: error?.message } });
    dispatch(setAlert({ title: error?.message, status: ALERT_STATUS_TYPE.ERROR }));
  }
};

// Routing Configs (API INTEGRATION)
export const getRoutingConfigs = () => async (dispatch) => {
  dispatch({ type: actionTypes.GETTING_ROUTING_CONFIGS });
  try {
    const { data } = await api.rda.getRoutingConfigs();
    dispatch({ type: actionTypes.GET_ROUTING_CONFIGS_SUCCESS, payload: data });
  } catch (error) {
    dispatch(setAlert({ title: error?.message, status: ALERT_STATUS_TYPE.ERROR }));
    dispatch({ type: actionTypes.GET_ROUTING_CONFIGS_FAIL, payload: { message: error?.message } });
  }
};

export const updateRoutingConfigs = (configs, onSuccess) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATING_ROUTING_CONFIGS });
  try {
    await api.rda.updateRoutingConfigs({ configs });
    dispatch({ type: actionTypes.UPDATING_ROUTING_CONFIGS_SUCCESS });
    onSuccess && onSuccess();
  } catch (error) {
    dispatch(setAlert({ title: error?.message, status: ALERT_STATUS_TYPE.ERROR }));
    dispatch({ type: actionTypes.UPDATING_ROUTING_CONFIGS_FAIL, payload: { message: error?.message } });
  }
};

export const getRoutingConfigMeta = () => async (dispatch) => {
  dispatch({ type: actionTypes.GETTING_ROUTING_CONFIG_META });
  try {
    const { data } = await api.rda.getRoutingConfigMeta();
    dispatch({ type: actionTypes.GET_ROUTING_CONFIG_META_SUCCESS, payload: data });
  } catch (error) {
    dispatch(setAlert({ title: error?.message, status: ALERT_STATUS_TYPE.ERROR }));
    dispatch({ type: actionTypes.GET_ROUTING_CONFIG_META_FAIL, payload: { message: error?.message } });
  }
};
export const getRdaMetaData = () => async (dispatch) => {
  dispatch({ type: actionTypes.GETTING_META_DATA });
  try {
    const { data } = await api.rdaDashboard.getMetaData();
    dispatch({ type: actionTypes.GET_META_DATA_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: actionTypes.GET_META_DATA_FAIL, payload: { message: error?.message } });
    dispatch(setAlert({ title: error?.message, status: ALERT_STATUS_TYPE.ERROR }));
  }
};

